import React from 'react';
import biblestudy from '../img/biblestudy.jpg';

const BiblestudyImage = () => (
  <img src={biblestudy} alt="Biblestudy Image" />
);

export default BiblestudyImage;
